var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardList--inner",class:_vm.firstRowThreeColsFunc},_vm._l((_vm.cardContent),function(card){return _c('Card',{key:card.title,attrs:{"layoutProduct":'layoutProduct',"card":card,"layoutElemSpace":'mb-4'}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }